// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/weather_actual_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { AreaWeatherActual } from "./weather_actual_model_pb";
import { file_bffuser_v1_weather_actual_model } from "./weather_actual_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/weather_actual_service.proto.
 */
export const file_bffuser_v1_weather_actual_service: GenFile = /*@__PURE__*/
  fileDesc("CidiZmZ1c2VyL3YxL3dlYXRoZXJfYWN0dWFsX3NlcnZpY2UucHJvdG8SCmJmZnVzZXIudjEiuwEKG0dldEFyZWFXZWF0aGVyQWN0dWFsUmVxdWVzdBI0CglhcmVhX2NvZGUYASABKA4yFS5iZmZ0eXBlcy52MS5BcmVhQ29kZUIKukgHggEEEAEgABIzChB0YXJnZXRfZGF0ZV9mcm9tGAIgASgLMhEuZ29vZ2xlLnR5cGUuRGF0ZUIGukgDyAEBEjEKDnRhcmdldF9kYXRlX3RvGAMgASgLMhEuZ29vZ2xlLnR5cGUuRGF0ZUIGukgDyAEBIk0KHEdldEFyZWFXZWF0aGVyQWN0dWFsUmVzcG9uc2USLQoGYWN0dWFsGAEgASgLMh0uYmZmdXNlci52MS5BcmVhV2VhdGhlckFjdHVhbCLNAQohQmF0Y2hHZXRBcmVhV2VhdGhlckFjdHVhbHNSZXF1ZXN0EkAKCmFyZWFfY29kZXMYASADKA4yFS5iZmZ0eXBlcy52MS5BcmVhQ29kZUIVukgSkgEPCAEQChgBIgeCAQQQASAAEjMKEHRhcmdldF9kYXRlX2Zyb20YAiABKAsyES5nb29nbGUudHlwZS5EYXRlQga6SAPIAQESMQoOdGFyZ2V0X2RhdGVfdG8YAyABKAsyES5nb29nbGUudHlwZS5EYXRlQga6SAPIAQEiVAoiQmF0Y2hHZXRBcmVhV2VhdGhlckFjdHVhbHNSZXNwb25zZRIuCgdhY3R1YWxzGAEgAygLMh0uYmZmdXNlci52MS5BcmVhV2VhdGhlckFjdHVhbDKCAgoUV2VhdGhlckFjdHVhbFNlcnZpY2USawoUR2V0QXJlYVdlYXRoZXJBY3R1YWwSJy5iZmZ1c2VyLnYxLkdldEFyZWFXZWF0aGVyQWN0dWFsUmVxdWVzdBooLmJmZnVzZXIudjEuR2V0QXJlYVdlYXRoZXJBY3R1YWxSZXNwb25zZSIAEn0KGkJhdGNoR2V0QXJlYVdlYXRoZXJBY3R1YWxzEi0uYmZmdXNlci52MS5CYXRjaEdldEFyZWFXZWF0aGVyQWN0dWFsc1JlcXVlc3QaLi5iZmZ1c2VyLnYxLkJhdGNoR2V0QXJlYVdlYXRoZXJBY3R1YWxzUmVzcG9uc2UiAEJAWj5naXRodWIuY29tL2VuZWNoYWluL2ViYWxhbmNlL2dvL2dlbi9wcm90by9iZmZ1c2VyL3YxO2JmZnVzZXJ2MWIGcHJvdG8z", [file_bfftypes_v1_area, file_bffuser_v1_weather_actual_model, file_buf_validate_validate, file_google_type_date]);

/**
 * GetAreaWeatherActualRequest carries the area and inclusive target-date
 * range.
 *
 * @generated from message bffuser.v1.GetAreaWeatherActualRequest
 */
export type GetAreaWeatherActualRequest = Message<"bffuser.v1.GetAreaWeatherActualRequest"> & {
  /**
   * Target electricity area. UNSPECIFIED is rejected.
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 1;
   */
  areaCode: AreaCode;

  /**
   * Inclusive start of the target-date range.
   *
   * @generated from field: google.type.Date target_date_from = 2;
   */
  targetDateFrom?: Date;

  /**
   * Inclusive end of the target-date range. Must be >= target_date_from.
   *
   * @generated from field: google.type.Date target_date_to = 3;
   */
  targetDateTo?: Date;
};

/**
 * Describes the message bffuser.v1.GetAreaWeatherActualRequest.
 * Use `create(GetAreaWeatherActualRequestSchema)` to create a new message.
 */
export const GetAreaWeatherActualRequestSchema: GenMessage<GetAreaWeatherActualRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_weather_actual_service, 0);

/**
 * @generated from message bffuser.v1.GetAreaWeatherActualResponse
 */
export type GetAreaWeatherActualResponse = Message<"bffuser.v1.GetAreaWeatherActualResponse"> & {
  /**
   * @generated from field: bffuser.v1.AreaWeatherActual actual = 1;
   */
  actual?: AreaWeatherActual;
};

/**
 * Describes the message bffuser.v1.GetAreaWeatherActualResponse.
 * Use `create(GetAreaWeatherActualResponseSchema)` to create a new message.
 */
export const GetAreaWeatherActualResponseSchema: GenMessage<GetAreaWeatherActualResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_weather_actual_service, 1);

/**
 * BatchGetAreaWeatherActualsRequest carries the areas and the inclusive target-date range
 * shared by every area.
 *
 * @generated from message bffuser.v1.BatchGetAreaWeatherActualsRequest
 */
export type BatchGetAreaWeatherActualsRequest = Message<"bffuser.v1.BatchGetAreaWeatherActualsRequest"> & {
  /**
   * Target electricity areas (1 to 10, no duplicates). UNSPECIFIED is
   * rejected.
   *
   * @generated from field: repeated bfftypes.v1.AreaCode area_codes = 1;
   */
  areaCodes: AreaCode[];

  /**
   * Inclusive start of the target-date range.
   *
   * @generated from field: google.type.Date target_date_from = 2;
   */
  targetDateFrom?: Date;

  /**
   * Inclusive end of the target-date range. Must be >= target_date_from.
   *
   * @generated from field: google.type.Date target_date_to = 3;
   */
  targetDateTo?: Date;
};

/**
 * Describes the message bffuser.v1.BatchGetAreaWeatherActualsRequest.
 * Use `create(BatchGetAreaWeatherActualsRequestSchema)` to create a new message.
 */
export const BatchGetAreaWeatherActualsRequestSchema: GenMessage<BatchGetAreaWeatherActualsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_weather_actual_service, 2);

/**
 * @generated from message bffuser.v1.BatchGetAreaWeatherActualsResponse
 */
export type BatchGetAreaWeatherActualsResponse = Message<"bffuser.v1.BatchGetAreaWeatherActualsResponse"> & {
  /**
   * One element per requested area, in request order.
   *
   * @generated from field: repeated bffuser.v1.AreaWeatherActual actuals = 1;
   */
  actuals: AreaWeatherActual[];
};

/**
 * Describes the message bffuser.v1.BatchGetAreaWeatherActualsResponse.
 * Use `create(BatchGetAreaWeatherActualsResponseSchema)` to create a new message.
 */
export const BatchGetAreaWeatherActualsResponseSchema: GenMessage<BatchGetAreaWeatherActualsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_weather_actual_service, 3);

/**
 * WeatherActualService provides observed weather (JMA AMeDAS, koma-aggregated)
 * for the balance-monitoring screens.
 *
 * @generated from service bffuser.v1.WeatherActualService
 */
export const WeatherActualService: GenService<{
  /**
   * GetAreaWeatherActual returns the koma-aggregated observation series for
   * the area and target-date range. organization_id is resolved by the BFF
   * handler from eauth.
   *
   * @generated from rpc bffuser.v1.WeatherActualService.GetAreaWeatherActual
   */
  getAreaWeatherActual: {
    methodKind: "unary";
    input: typeof GetAreaWeatherActualRequestSchema;
    output: typeof GetAreaWeatherActualResponseSchema;
  },
  /**
   * BatchGetAreaWeatherActuals returns one actual per requested area, in request order
   * (area_code identifies each element), for the shared target-date range.
   * organization_id is resolved by the BFF handler from eauth.
   *
   * @generated from rpc bffuser.v1.WeatherActualService.BatchGetAreaWeatherActuals
   */
  batchGetAreaWeatherActuals: {
    methodKind: "unary";
    input: typeof BatchGetAreaWeatherActualsRequestSchema;
    output: typeof BatchGetAreaWeatherActualsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_weather_actual_service, 0);

